import type { SelectedAccountRef } from '../system-admin-ui-config';
import type { AccountRowState } from './use-consolidated-metrics';
import { AccountMetricsRow } from './account-metrics-row';

interface ConsolidatedMetricsListProps {
  accounts: SelectedAccountRef[];
  rows: Record<number, AccountRowState>;
  onOpen: (account: SelectedAccountRef) => void;
  onRemove: (id: string) => void;
  onRetry: (accountId: number) => void;
}

export function ConsolidatedMetricsList({
  accounts,
  rows,
  onOpen,
  onRemove,
  onRetry,
}: ConsolidatedMetricsListProps) {
  return (
    <div className='divide-y divide-gray-200 overflow-hidden rounded-2xl border border-gray-200 bg-white'>
      {accounts.map((account) => (
        <AccountMetricsRow
          key={account.id}
          account={account}
          state={rows[Number(account.id)]}
          onOpen={onOpen}
          onRemove={onRemove}
          onRetry={onRetry}
        />
      ))}
    </div>
  );
}
